import catalog from "./en.json";

const lookup = (node, path) =>
  path.split(".").reduce((acc, key) => (acc == null ? acc : acc[key]), node);

/**
 * Look up a catalog string by dotted key and interpolate `{name}` tokens.
 * A missing key is a programmer error — never fall back to the key itself.
 */
export function t(key, vars) {
  const value = lookup(catalog, key);
  if (typeof value !== "string") {
    throw new Error(`Missing copy key: ${key}`);
  }
  return value.replace(/\{(\w+)\}/g, (_, name) => {
    if (
      !vars ||
      !Object.prototype.hasOwnProperty.call(vars, name) ||
      vars[name] == null
    ) {
      throw new Error(`Missing copy interpolation: ${name} in ${key}`);
    }
    return String(vars[name]);
  });
}
